export default function CapitalizeFirstLetter(str) {
  // remove any trailing spaces
  str = str.trim();

  // capitalize
  str = str.charAt(0).toUpperCase() + str.slice(1);

  return str;
}
